import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d2a370ca"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "subhead"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "tip-wrap",
    style: _normalizeStyle(_ctx.wrapStyle)
  }, [_createElementVNode("p", {
    class: _normalizeClass(["headline", {
      'alone-headline': !_ctx.subhead
    }])
  }, _toDisplayString(_ctx.title), 3), _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.subhead), 1)], 4);
}